import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $events from 'wee-events';
import $mediator from 'wee-mediator';
import $screen from 'wee-screen';

class Section {
    constructor(sectionElement) {
        this.$element = $(sectionElement);
        this.$content = this.$element.find('.section__content');
        this.$button = this.$element.find('.section__trigger');
        this.$trigger = this.$element.find('.section__heading-wrapper .-collapsible-trigger');
        this.$wrapper = this.$element.find('.section__heading-wrapper');
        this.$featuresBtns = this.$content.find('.feature__heading-wrapper');

        $mediator.on('sectionJump', (subject) => {
            if (this.$element.attr('id') === subject) {
                this.expand();
            }
        });
    }

    collapse() {
        this.$button.attr('aria-expanded', 'false');
        this.$content.attr('aria-hidden', 'true');
        this.$content.addClass('-collapsed').removeClass('-expanded');
        this.$trigger.addClass('-collapsed').removeClass('-expanded');

        // Prevent feature buttons from being focusable while the feature section is collapsed.
        for (let i = 0; i < this.$featuresBtns.length; i++) {
            this.$featuresBtns[i].tabIndex = '-1';
        }

        this.resizeSection();
    }

    expand() {
        this.$button.attr('aria-expanded', 'true');
        this.$content.attr('aria-hidden', 'false');
        this.$content.addClass('-expanded').removeClass('-collapsed');
        this.$trigger.addClass('-expanded').removeClass('-collapsed');

        // Make feature buttons focusable while the feature section is expanded.
        for (let i = 0; i < this.$featuresBtns.length; i++) {
            this.$featuresBtns[i].tabIndex = 0;
        }

        this.resizeSection();
    }

    getElementHeight() {
        if (this.$content.hasClass('-expanded')) {
            const children = this.$content.children();
            let height = this.$content[0].scrollHeight;

            for (let i = 0; i < children.length; i++) {
                height += children[i].scrollHeight;
            }

            return height / 10;
        }

        return 0;
    }

    resizeSection() {
        const height = $screen.size() > 3 ? 'none' : `${this.getElementHeight()}rem`;

        this.$content.css('max-height', height);
    }

    toggleExpand() {
        // eslint-disable-next-line no-unused-expressions
        this.$content.hasClass('-collapsed')
            ? this.expand()
            : this.collapse();
        this.$trigger.addClass('fade-in');

        setTimeout(() => {
            this.$trigger.removeClass('fade-in');
        }, 700);
    }
}

export default new RouteHandler({
    init() {
        $(':section').each((el, i) => {
            const section = new Section(el);

            $screen.map([
                {
                    each: true,
                    callback() {
                        section.resizeSection();
                    },
                },
                {
                    max: 3,
                    callback() {
                        if (section.$element.find(':carousel').length) {
                            section.expand();

                            if (i !== 0) {
                                setTimeout(() => {
                                    section.collapse();
                                }, 1000);
                            }
                        } else if (i === 0) {
                            section.expand();
                        } else if (i !== 0) {
                            section.collapse();
                        }

                        $events.on(section.$content, 'click.section', () => {
                            window.setTimeout(() => {
                                section.resizeSection();
                            }, 500);
                        });

                        $events.on(section.$wrapper, 'click.section', () => section.toggleExpand());

                        section.$button.attr('tabindex', 0);
                    },
                }, {
                    min: 4,
                    callback() {
                        section.expand();
                        $events.off(false, '.section');
                        section.$button.attr('tabindex', -1);
                    },
                },
            ]);
        });
    },
});
